import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './containers/Home';
import Login from './containers/Login';
import Signup from './containers/Signup';
import Activate from './containers/Activate';
import ResetPassword from './containers/ResetPassword';
import ResetPasswordConfirm from './containers/ResetPasswordConfirm';

import Systems from './containers/Systems';
import Geofence from './containers/Geofence';
import Soilmaps from './containers/Soilmaps';
import Soilprobes from './containers/Soilprobes';
import Probeloc from './containers/Probeloc';
import { Provider } from 'react-redux';
import store from './store';

import Layout from './hocs/Layout';
import PrivateRoute from './components/PrivateRoute';
import Livemaps from './containers/Livemaps';


const App = () => (
    <Provider store={store}>
        <Router>
            <Layout>
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/signup' element={<Signup />} />
                    <Route path='/reset-password' element={<ResetPassword />} />
                    <Route path='/password/reset/confirm/:uid/:token' element={<ResetPasswordConfirm />} />
                    <Route path='/activate/:uid/:token' element={<Activate />} />   
                    
                    {/* Private routes */}
                    <Route element={<PrivateRoute />}>
                        <Route path='/systems' element={<Systems />} />
                        <Route path='/geofence' element={<Geofence />} />
                        <Route path='/maps' element={<Soilmaps />} />
                        <Route path='/probes' element={<Soilprobes />} />
                        <Route path='/probelocation' element={<Probeloc />} />
                        <Route path='/livemaps' element={<Livemaps />} />
                    </Route>
                </Routes>
            </Layout>
        </Router>
    </Provider>
);

export default App;
